import { Card, Container } from "react-bootstrap";
import { ClientMultiSelectDropdown } from "src/components/parts/ClientMultiSelectDropdown";
import { useState } from "react";
import { Nullable } from "@jamesgmarks/utilities";
import { IClientDropdownItem } from "src/entity-interfaces/IClientDropdownItem";

export const ComponentPlayground = () => {
  // place variables here

  const [searchClients, setSearchClients] =useState<Nullable<IClientDropdownItem[]>>(null);

  return (
    <Container>
      <h3>Component Playground</h3>
      <Card>
        {searchClients?.map((client) => client.billingAccountId)}
        <ClientMultiSelectDropdown
          onClientChanged={
            (client) => {
              setSearchClients(client);
            }
          }
        />
      </Card>
    </Container>
  );
};
